/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A JSON Web Key Set — a named collection of published public keys backed by an organization external key.
 */
export type JSONWebKeySet = {
  /**
   * When the key set was created.
   */
  createdAt: Date;
  /**
   * The external key currently backing the set: new keys are published from it. Already-published keys keep signing with the external key they were minted from.
   */
  externalKeyId: string;
  /**
   * The ID of the key set.
   */
  id: string;
  /**
   * A human-readable name for the key set.
   */
  name: string;
  /**
   * The organization that owns the key set.
   */
  organizationId: string;
  /**
   * When the key set was last updated.
   */
  updatedAt: Date;
};

/** @internal */
export const JSONWebKeySet$inboundSchema: z.ZodMiniType<
  JSONWebKeySet,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    external_key_id: z.string(),
    id: z.string(),
    name: z.string(),
    organization_id: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "external_key_id": "externalKeyId",
      "organization_id": "organizationId",
      "updated_at": "updatedAt",
    });
  }),
);

export function jsonWebKeySetFromJSON(
  jsonString: string,
): SafeParseResult<JSONWebKeySet, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => JSONWebKeySet$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'JSONWebKeySet' from JSON`,
  );
}
